export default __webpack_public_path__ + "static/media/bar1Animation.9e10efef.svg";